exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-5ad823d2]::after  {\n    content: '*';\n    color: red;\n    margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-5ad823d2] {\n    font-weight: 100;\n    color: red;\n    position: initial;\n    text-align: left;\n    height: auto;\n    width: auto;\n}\n.has-danger[data-v-5ad823d2] {\n    color: red\n}\n.gradientbt[data-v-5ad823d2]{\n    background: #0F6940;\n    color: white\n}\n.box-body[data-v-5ad823d2] {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5ad823d2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/reportschedule/ReportScheduleDetails.vue
// module id = 179
// module chunks = 0